import { Component, OnInit, Input } from '@angular/core';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { LocalsService } from 'src/app/locals/locals.service';

@Component({
  selector: 'app-assign-local',
  templateUrl: './assign-local.component.html',
  styleUrls: ['./assign-local.component.css']
})
export class AssignLocalComponent implements OnInit {

  @Input() experienceForm: DVFormGroup;

  locals = [];

  constructor(
    private localApi: LocalsService
  ) { }

  ngOnInit() {
    this.experienceForm.controls.cityId.valueChanges.subscribe(newValue => {
      if (newValue) {
        this.getLocalsByCityId(newValue);
      } else {
        this.locals = [];
      }
    });
  }


  private getLocalsByCityId(cityId) {
    this.localApi.getAllLocals({
      cityId
    }).subscribe(response => {
      this.locals = response.data.locals;
    });
  }

}
